import React, { FC } from "react";
import { Row, Col, Card, Progress, Empty } from "antd";
import "./progress-card.scss";
import CustomTooltip from "@pages/tool-tip";
import { ReadMore } from "@components/readMore/readMore";
import { getProgressColorCode } from "@pages/utils/utils";
import DataNotFound from "@components/noDataFound";
// import { useConfigStore } from "@stores/useConfigStore";

const ProgressCardDesc: FC<any> = (props) => {
  // const config = useConfigStore((state) => state.config);
  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip toolTipvalue={headerValue} children={<span style={{ margin: "6px 8px" }} className="icon icon-info clr-lightGrayColor"></span>} />
    </>
  );

  return (
    <Col span={props.size}>
      <Card style={{ height: props.cardHeight }} className="progress-card">
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: (props.cardHeight * 2) / 20,
            }}
            span={24}
          >
            {/* {props?.name} */}
            {/* <span
              className="icon icon-info clr-lightGrayColor"
              style={{ margin: "6px 10px" }}
            ></span> */}
            {getHeading(props?.name)}
          </Col>
          {props?.value !== 999 ? (
            <>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: (props.cardHeight * 7) / 20,
                }}
                span={24}
              >
                <Progress
                  type="circle"
                  percent={props?.value ? props.value : 0}
                  strokeColor={getProgressColorCode(props.scoreFlag)}
                  format={(percent) => {
                    return `${percent} %`;
                  }}
                />
              </Col>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: (props.cardHeight * 1.5) / 20,
                }}
                span={24}
              >
                <span style={{ color: "#b3bac5", fontSize: "14px" }}>{props.percent}</span>
              </Col>
              {props.info && (
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: (props.cardHeight * 1) / 20,
                  }}
                  span={24}
                >
                  <span
                    style={{
                      color: "#42526e",
                      fontSize: "16px",
                      fontWeight: "normal",
                    }}
                  >
                    {props.info}
                  </span>
                </Col>
              )}
              <Col style={{ display: "flex" }} span={24}>
                <Row>
                  <span
                    style={{
                      color: "#42526e",
                      fontSize: "16px",
                      fontWeight: 500,
                    }}
                  >
                    {props?.heading}
                  </span>
                </Row>
              </Col>
              <ReadMore text={props.factors} />
            </>
          ) : (
            <span style={{ marginTop: 100 }}>
              <DataNotFound message="Data will be available once EMR is received." />
            </span>
          )}
        </Row>
      </Card>
    </Col>
  );
};

export default ProgressCardDesc;
